import * as React from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm, InjectedFormProps } from "redux-form";

import { TextInput } from "../../../components";
import validate from "../login-form-validation";

export interface LoginFormValues {
  email: string;
  password: string;
}

export interface AugmentedLoginFormProps
  extends InjectedFormProps<LoginFormValues> {}

const LoginForm = (props: AugmentedLoginFormProps) => (
  <form onSubmit={props.handleSubmit}>
    <Field
      component={TextInput}
      className="form-group"
      type="email"
      name="email"
      placeholder="Email của bản"
    />
    <Field
      component={TextInput}
      className="form-group"
      type="password"
      name="password"
      placeholder="Mật khẩu"
    />
    <div className="form-group form-btn">
      <button
        type="submit"
        className="btn submit-btn"
        disabled={props.submitting}
      >
        Đăng nhập{" "}
        {props.submitting && <i className="fa fa-fw fa-pulse fa-spinner" />}
      </button>
      <Link className="forget" to="/account/register">
        Chưa có tài khoản?
      </Link>
    </div>
  </form>
);

export default reduxForm<LoginFormValues>({
  form: "login-form",
  validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/routes/Account/components/LoginForm.tsx